export default __webpack_public_path__ + "static/media/LCD.830e835f.png";